module.exports = __webpack_public_path__ + "img/default-question-age-group.658820a0.svg";